import { useContext, useState, useEffect } from "react";
import { PWAContext } from "../auth/PWAContext";
import { Button,Tooltip, useTheme,useMediaQuery } from '@mui/material';

export default function InstallPWAButton() {
  const { deferredPrompt, canInstall, setCanInstall } = useContext(PWAContext);
  console.log("PWAContext",deferredPrompt);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  console.log("isMobile",isMobile);
  //DEBUG: log di stato
  useEffect(() => {console.log("PWAContext aggiornato:",
  { deferredPrompt,canInstall });
  }, [deferredPrompt,canInstall]);
  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    console.log("Install outcome:", outcome);
    setCanInstall(false); // nasconde il bottone dopo l'installazione
  };

  if (!canInstall) return null;

  return (
  <Tooltip title="Installa sul tuo dispositivo mobile per accesso rapido e notifiche">
    <Button variant="contained" color="secondary" onClick={handleInstall}
    sx={{fontSize: !isMobile ? '0.8rem':'1rem',
    minWidth:!isMobile ? '120px':'160px',
    }}
    >
      Installa App
    </Button>
    </Tooltip>
  );
}